'use strict';

export default class Filter {
	constructor() {
		this.active = true;
	}

	setActive(active) {
		this.active = active;
	}

	test(filterItem) {
		// Either run the test or always return true
		return this.active ? this._test(filterItem) : true;
	}

	_test(filterItem) {
		return true;
	}
}